/**
 * Events-wall tokens (docs: events-wall handoff, "Tokens").
 *
 * The filter controls have no borders at all. Every state is a 2px transparent border with the
 * fill layered in: off is flat grey, open lets the Portal ring's colours show through as the
 * border, active is black with the same ring around it.
 */
export const RING_STOPS = ['#FD199F', '#FF33C6', '#B5B1FF', '#127BFD', '#22ECFB', '#FAE1B4', '#FCAA6D'];
export const RING = `linear-gradient(90deg, ${RING_STOPS.join(', ')}, ${RING_STOPS[0]})`;

export const OFF_FILL = '#F2F2F2';
export const fillFor = (state) => {
  if (state === 'on') return `linear-gradient(#000,#000) padding-box, ${RING} border-box`;
  if (state === 'open') return `linear-gradient(#fff,#fff) padding-box, ${RING} border-box`;
  return OFF_FILL;
};

/**
 * The same three states on a BLACK surface (the FILTERS drawer went dark, Oct 14 2026): off is
 * the near-black chip, open is the black fill with the ring, and ON is white with the ring —
 * the inverse of the light version, which other surfaces still use unchanged.
 */
export const OFF_FILL_DARK = '#161616';
export const fillForDark = (state) => {
  if (state === 'on') return `linear-gradient(#fff,#fff) padding-box, ${RING} border-box`;
  if (state === 'open') return `linear-gradient(#000,#000) padding-box, ${RING} border-box`;
  return `${OFF_FILL_DARK} padding-box`;
};
/** The text that goes on each of those. */
export const inkForDark = (state) => (state === 'on' ? '#000' : state === 'open' ? '#fff' : '#BDBDBD');

export const COLORS = {
  signal: '#00FFFF',
  live: '#FF00AA',
  starter: '#FF00FF',
  featured: '#FFCCE6',
  muted: '#6B7280',
  subtle: '#9CA3AF',
  fundTrack: '#FBD5FB',
};

/** Page gutter: 16px on phones (< 640), 28px everywhere else. */
export const gutter = (phone) => (phone ? 16 : 28);

/** The DS's one sanctioned drawer / panel curve for this page. */
export const EASE = 'cubic-bezier(.2,.7,.2,1)';

/**
 * The disco frame — the FILTERS pill's moving ring, as a 2px border on any box: a transparent
 * border with the ring gradient and a white shimmer layered into the border box, both sliding
 * 160px every 2.4s. `fill` is what the inside shows. Pair with DISCO_KEYFRAMES once on the page.
 */
export const SHIMMER = 'linear-gradient(100deg, rgba(255,255,255,0) 35%, rgba(255,255,255,.7) 50%, rgba(255,255,255,0) 65%)';
export function discoFrame({ reduced = false, fill = '#fff' } = {}) {
  return {
    border: '2px solid transparent',
    backgroundImage: `linear-gradient(${fill}, ${fill}), ${SHIMMER}, ${RING}`,
    backgroundOrigin: 'padding-box, border-box, border-box',
    backgroundClip: 'padding-box, border-box, border-box',
    backgroundSize: '100% 100%, 160px 100%, 160px 100%',
    animation: reduced ? 'none' : 'prDiscoFrame 2.4s linear infinite',
  };
}
export const DISCO_KEYFRAMES = `
  @keyframes prDiscoFrame { 0% { background-position: 0 0, 0 0, 0 0; } 100% { background-position: 0 0, 160px 0, 160px 0; } }
  @media (prefers-reduced-motion: reduce) { [data-disco] { animation: none !important; } }
`;
